import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { BlockTextComponent } from '../../../common/block-text/block-text.component';
import { NotificationComponent } from '../../../common/notification/notification.component';
import { BaseComponent } from '../../../common/BaseComponent';
import { PinComponent } from '../../../common/pin/pin.component';
import { Helper } from '../../../../../utils/helper';
import { MetaCarouselPrimaryTextInitModel, MetaCarouselPrimaryTextInitVariables, MetaCarouselPrimaryTextModel, MetaCarouselPrimaryTextVariables } from '../../../../../models/meta-template/meta-carousel-primary-text.interface';

@Component({
    selector: 'app-meta-carousel-primary-text',
    imports: [
        CommonModule,
        ReactiveFormsModule,
        BlockTextComponent,
        NotificationComponent,
        PinComponent,
    ],
    templateUrl: './meta-carousel-primary-text.component.html',
    changeDetection: ChangeDetectionStrategy.Eager
})
export class MetaCarouselPrimaryTextComponent extends BaseComponent implements OnInit {
  //@ input
  @Input() block: MetaCarouselPrimaryTextModel = new MetaCarouselPrimaryTextInitModel();
  @Input() isPreview = false;
  //@ output
  @Output() blockData = new EventEmitter<any>(); // Event emitter to send data to the parent
  @Output() removeBlockEvent = new EventEmitter<string | null>(); // New EventEmitter for remove

  ngOnInit() {
    if (Helper.isEmpty(this.block.variables!)) {
      this.block.variables = new MetaCarouselPrimaryTextInitVariables()
    }
  }

  //@ placeholders
  primaryTextPlaceholder: string = 'Enter primary text (max 80 characters)';

  //@remove
  removeBlock(): void {
    this.removeBlockEvent.emit(this.block.blockId); // Emit the ID to parent
  }

  //@onChange
  onChange(value: any, fieldName: keyof MetaCarouselPrimaryTextVariables) {
    if (this.block.variables) {
      this.block.variables[fieldName] = value;
      this.blockData.emit(this.block);
    }
  }

  onContainerClick(event: MouseEvent) {
    // Forward the click event to the child app-pin component
    this.pinComponent.onContainerClick(event);
  }
}
